export const MAINTENANCE_BANNER_HEIGHT = '80px';
